import TemplatePreview from '@tools/components/template-preview/template-preview.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { Template } from '@tools/interfaces/template';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import EntityStructure from '@/app/modules/tools/components/entity-structure/entity-structure.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-template-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-entity-structure': EntityStructure,
    'bpc-template-preview': TemplatePreview,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-std-filter': StdFilter,
  },
})
export default class TemplateTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    cloneConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  public entity: Template = null;
  public entityName = 'template';
  public pluralEntityName = 'templates';
  public formModel: AnyEntity = {};
  public customPageActions = {};
  public customRowActions = {};
  isCloningTemplate: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
  ];

  constructor() {
    super();
  }

  public beforeDefaultRowActions = {
    clone: {
      activated: true,
      type: 'action',
      icon: 'clone',
      show: false,
      event: 'clone-template',
      text: 'clone_template',
      permissions: ['store'],
    },
  };

  get rowActions() {
    return {
      ...this.beforeDefaultRowActions,
      ...this.defaultRowActions,
      ...this.customRowActions,
    };
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.clone.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'clone-template':
        this.openCloneTemplateModal($event.item.item);
        break;
    }
  }

  openCloneTemplateModal(item) {
    this.$refs.cloneConfirmationModal.onOpenModal(item.id);
  }

  closeCloneTemplateModal() {
    this.$refs.cloneConfirmationModal.onCloseModal();
  }

  confirmCloneTemplate($event) {
    const id = $event.entityIdOrIds;
    this.isCloningTemplate = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('template');
    const relativePath = '/clone/' + id;

    this.$bpcApi
      .post(basePath + relativePath, {
        id: id,
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          this.closeCloneTemplateModal();
          this.isCloningTemplate = false;
        },
        error => {
          this.$bvModal.hide('modal-cancel-subscriptions');
          this.closeCloneTemplateModal();
          this.isCloningTemplate = false;
        },
      );
  }

  get cloneTemplateConfirmationModalConfig() {
    return {
      id: this.entityName + '-clone-modal-' + this.generateUUIDv4(),
      title: this.$t('global.modals.clone_template.title'),
      body: this.$t('global.modals.clone_template.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  openTemplateVariables = false;

  onInputCustomEvent(event) {
    const eventName = event.eventName;
    switch (eventName) {
      case 'open_template_variables':
        this.openTemplateVariables = true;
        break;
      case 'close_template_variables':
        this.openTemplateVariables = false;
        break;
      default:
        break;
    }
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
